module.exports = __webpack_public_path__ + "70f0cb6cc03ebd905285686d37bfb8a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/media1.jpg
// module id = 189
// module chunks = 0